import { style } from '@vanilla-extract/css'

const section = style({
  position: 'relative',
  width: '100%',
})

const lines = style({
  position: 'absolute',
  left: '24px',
  top: '32px',
})

const text = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#252525',
})

export const styles = {
  section,
  lines,
  text,
}
